import { Checkbox, FormControlLabel, Grid, Slider, Typography } from '@mui/material';
import { Weekday } from '@thro-types/leihbar';

import { useTranslation } from 'react-i18next';

import { formatTimeFromMinutes } from 'app/containers/LeihBar/date.helper';
import { translations } from 'locales/i18n';

import { RecurringIntervalValue } from '..';

interface Props<T extends string> {
  index: number;
  fieldName: T;
  values: { weekdays: Weekday[]; start: number; end: number }[];
  setFieldValue: (fieldName: T, value: RecurringIntervalValue[]) => void;
}

export const RecurringIntervalPicker = <T extends string>({
  index,
  fieldName,
  values,
  setFieldValue
}: Props<T>) => {
  const { t } = useTranslation();

  const handleDayToggle = day => {
    let updatedIntervals = [...values];
    if (values[index].weekdays.includes(day)) {
      updatedIntervals[index].weekdays = updatedIntervals[index].weekdays.filter(
        item => item !== day
      );
    } else {
      updatedIntervals[index].weekdays.push(day);
    }
    setFieldValue(fieldName, updatedIntervals);
  };

  const handleSliderChange = (newValues: number | number[]) => {
    let updatedIntervals = [...values];
    updatedIntervals[index].start = newValues[0];
    updatedIntervals[index].end = newValues[1];

    setFieldValue(fieldName, updatedIntervals);
  };

  const marks = [
    {
      value: 0,
      label: '00:00'
    },
    {
      value: 480,
      label: '08:00'
    },
    {
      value: 960,
      label: '16:00'
    },
    {
      value: 1439,
      label: '23:59'
    }
  ];
  return (
    <Grid container justifyContent={'space-between'}>
      <Grid item>
        {Object.values(Weekday).map(wd => {
          return (
            <FormControlLabel
              id="day"
              key={wd}
              name="weekday"
              control={
                <Checkbox
                  checked={values[index].weekdays.includes(wd)}
                  onChange={() => handleDayToggle(wd)}
                />
              }
              label={t(translations.common.weekdaysShort[wd.toLowerCase()]())}
            />
          );
        })}
      </Grid>
      <Grid item alignSelf={'center'} xs={2}>
        <Typography>{`${formatTimeFromMinutes(values[index].start)} - ${formatTimeFromMinutes(
          values[index].end
        )}`}</Typography>
      </Grid>
      <Grid container item xs={12}>
        <Grid item xs={1} />
        <Grid item xs={10}>
          <Slider
            value={[values[index].start, values[index].end]}
            onChange={(event, newValues) => {
              handleSliderChange(newValues);
            }}
            valueLabelDisplay="auto"
            valueLabelFormat={v => {
              return formatTimeFromMinutes(v);
            }}
            min={0}
            max={1439}
            step={15}
            marks={marks}
          />
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </Grid>
  );
};
